import { render, staticRenderFns } from "./InfoAccordion.vue?vue&type=template&id=e4d07574&scoped=true&"
import script from "./InfoAccordion.vue?vue&type=script&lang=js&"
export * from "./InfoAccordion.vue?vue&type=script&lang=js&"
import style0 from "./InfoAccordion.vue?vue&type=style&index=0&id=e4d07574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d07574",
  null
  
)

export default component.exports